import Model from 'mewe/utils/store-utils/model/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { attr, hasMany } from 'mewe/utils/store-utils/model/attribute';
import QuestModel from './quest-model';

const model = Model.extend({
  questId: attr('number'),
  levelId: alias('questId'),
  number: alias('questId'),

  title: attr('string'),
  description: attr('string'),
  completed: attr('boolean'),
  enabled: attr('boolean'),
  quests: hasMany(QuestModel),
  levelAvatar: computed('number', function () {
    return `/assets/images/quests/avatar-lvl${this.get('number')}.png`;
  }),
  levelImage: computed('number', function () {
    return `/assets/images/quests/cover-lvl${this.get('number')}.png`;
  }),

  progressPct: computed('questsCompletedCount', function () {
    const progress = (this.get('questsCompletedCount') / this.get('quests').length) || 0;
    return Math.max(3, Math.round(progress * 100)); // set minimum progress to 3% so that the bar is not completly invisible
  }),
  questsCompletedCount: computed('quests.@each.completed', function () {
    return this.get('quests').filter((quest) => quest.get('completed')).length;
  }),
});

export default model;
